import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";
import { setUserLogin } from "../auth/authLoginSlice";
import { updateLastActivity } from "../auth/idleSlice";
import { setSession } from "../../common/utils";
import CryptoJS from "crypto-js";

// initial state
export const initialState = {
  loading: false,
  error: null,
  success: false,
  errorMessage: null,
  prosuiteDetails: null,
  isFileOpenedfromTT: false,
  TTFileID: 0,
};

// our slice
const secureLoginSlice = createSlice({
  name: "secureLogin",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.success = false;
    },
    setErrorMessage: (state, { payload }) => {
      state.errorMessage = payload;
      state.loading = false;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = false;
      state.success = true;
    },
    setProsuiteFileDetails: (state, { payload }) => {
      state.prosuiteDetails = {
        fileID: 100000 + parseInt(payload?.fileID),
      };
    },
    setisFileopenedfromTT: (state, { payload }) => {
      state.isFileOpenedfromTT = payload;
      state.loading = false;
    },
    setTTFileID: (state, { payload }) => {
      state.TTFileID = payload;
      state.loading = false;
    },
  },
});
// export the actions
export const {
  setLoading,
  setError,
  setErrorMessage,
  setSuccess,
  setProsuiteFileDetails,
  setisFileopenedfromTT,
  setTTFileID,
} = secureLoginSlice.actions;

export const secureLoginSelector = (state) => state.secureLogin;

// export the default reducer
export default secureLoginSlice.reducer;

// secure Login
export const LoadSecureLogin = (data, isOpenedfromTT) => async (dispatch) => {
  try {
    dispatch(setLoading());
    var requestData = {
      FromURLData: data,
      IsOpenedFromTT: isOpenedfromTT === "true" ? true : false,
    };
    const results = await http
      .post("User/ClientSecureLogin", requestData)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      if (
        results?.data?.responseObject?.prosuiteDetail?.errMsg === null ||
        results?.data?.responseObject?.isFileOpenedfromTT
      ) {
        dispatch(setUserLogin(results?.data?.responseObject?.userAuthenticate));
        dispatch(updateLastActivity());
        setSession();
        window.localStorage.setItem(
          "userInfo",
          CryptoJS.AES.encrypt(
            JSON.stringify(results?.data?.responseObject?.userAuthenticate),
            process.env.REACT_APP_CRYPTO_KEY
          ).toString()
        );
        if (
          isOpenedfromTT === undefined ||
          isOpenedfromTT === null ||
          isOpenedfromTT === "false"
        ) {
          dispatch(
            setProsuiteFileDetails(
              results?.data?.responseObject?.prosuiteDetail
            )
          );
        } else {
          dispatch(
            setisFileopenedfromTT(
              results?.data?.responseObject?.isFileOpenedfromTT
            )
          );
          dispatch(setTTFileID(results?.data?.responseObject?.fileID));
        }
        dispatch(setSuccess());
      } else {
        dispatch(
          setErrorMessage(results?.data?.responseObject?.prosuiteDetail.errMsg)
        );
      }
    } else {
      dispatch(setError(response.responseDescription));
    }
  } catch (error) {
    dispatch(setErrorMessage("Something went wrong! Try again later."));
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.title
        : error.message;
    dispatch(setError(errorMessage));
  }
};
